import { useEffect, useState } from "react";
import axios from "axios";

const ConstantUseFetchImageUrls = (query) => {
  const [imageUrls, setImageUrls] = useState({});
  const [error, setError] = useState(null);
  const baseUrl = "https://ignite.accenture.com/ignite-apis/";
  // const baseUrl = "http://localhost:5000";

  useEffect(() => {
    if (!query) {
      return;
    }

    const controller = new AbortController();
    const fetchImageUrls = async () => {
      try {
        const response = await axios.get(`${baseUrl}/images?${query}`, {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          signal: controller.signal,
        });
        setImageUrls(response.data);
      } catch (err) {
        console.error("Error fetching image URLs:", err);
        setError(err);
      }
    };

    fetchImageUrls();

    return () => {
      controller.abort();
    };
  }, [query]);

  return { imageUrls, error };
};

export default ConstantUseFetchImageUrls;
